<template>
	<div class="animated fadeIn">
		<b-card>
			<b-card-header>
				<i class="icon-menu mr-1"></i>管理員列表
				<div class="card-header-actions">
					<b-link v-if="!cannotEdit" @click="openEditor()"><i class="fa fa-plus"></i> 新增</b-link>
				</div>
			</b-card-header>
		  <b-card-body>
			<v-server-table :columns="columns" :data="data" :options="options" :theme="theme" ref="dataTable" id="dataTable">
				<a slot="firstname" slot-scope="props">{{props.row.firstname + ' ' + props.row.lastname}}</a>
				<a slot="user_id" slot-scope="props">{{props.row.Admin.firstname + ' ' + props.row.Admin.lastname}}</a>

				<a slot="company_id" slot-scope="props">{{props.row.Company?props.row.Company.name:'N/A'}}</a>
				<a slot="role_id" slot-scope="props">{{props.row.Role?props.row.Role.name:'N/A'}}</a>

				<div slot="child_row" slot-scope="props">
					<b-button variant="info" class="btn-pill" size="sm" v-if="!cannotEdit" @click="editRow(props.row.id, props.row)"><i class="fa fa-pencil"></i> 編輯</b-button> &nbsp;
					<b-button variant="warning" class="btn-pill" size="sm" v-if="!cannotEdit" @click="unlockUserLoginFail(props.row.id, props.row)"><i class="fa fa-pencil"></i> 帳號解鎖</b-button> &nbsp;
					<b-button variant="danger" class="btn-pill" size="sm" v-if="!cannotEdit" @click="delRow(props.row.id, props.row.firstname)"><i class="fa fa-times"></i> 刪除</b-button> &nbsp;
					<!-- <b-button class="btn-pill" size="sm" @click="testRow(props.row.id)"><i class="fa fa-wrench"></i>重新設定密碼</b-button> -->
				</div>
			</v-server-table>
		  </b-card-body>
		</b-card>

		<b-modal title="刪除管理員" size="sm" v-model="delRowShowModal" @ok="submitDelRow(delRowId)" ok-title="確定" cancel-title="取消">
	      {{delRowMsg}}
	    </b-modal>

	    <b-modal title="編輯器" class="modal-info" v-model="showEditorModal" :no-enforce-focus="true" @ok="submitRecord()" ok-title="儲存" cancel-title="取消" :ok-disabled="$v.$invalid">
	        <b-form>
              <h1>管理員資料</h1>
              <p class="text-muted">*為必填</p>
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                	<b-input-group-text><i class="cui-align-left"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="*First Name" 
                              v-model.lazy.trim="$v.record.firstname.$model"
                              v-focus
                              :state="chkState('firstname')"
                              aria-describedby="invalidFNFeedback"/>
                <b-form-invalid-feedback id="invalidFNFeedback">必填</b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                	<b-input-group-text><i class="cui-align-right"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="*Last Name" 
                              v-model.lazy.trim="$v.record.lastname.$model"
                              v-focus
                              :state="chkState('lastname')"
                              aria-describedby="invalidLNFeedback"/>
                <b-form-invalid-feedback id="invalidLNFeedback">必填</b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                	<b-input-group-text><i class="cui-globe"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-select id="device-company-id"
                              class="form-control hidden" 
                              placeholder="*Company" 
                              v-model.lazy.trim="$v.record.company_id.$model"
                              v-focus
                              :state="chkState('company_id')"
                              aria-describedby="invalidCNFeedback"/>
                <b-form-invalid-feedback id="invalidCNFeedback">必填</b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-user-secret"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-select id="device-role-id"
                              class="form-control hidden" 
                              placeholder="*Role" 
                              v-model.lazy.trim="$v.record.role_id.$model"
                              v-focus
                              :state="chkState('role_id')"
                              aria-describedby="invalidRLFeedback"/>
                <b-form-invalid-feedback id="invalidRLFeedback">必填</b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                	<b-input-group-text><i class="cui-user-follow"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="*Contact" 
                              v-model.lazy.trim="$v.record.contact.$model"
                              v-focus
                              :state="chkState('contact')"
                              aria-describedby="invalidCCFeedback"/>
                <b-form-invalid-feedback id="invalidCCFeedback">必填</b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-at"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="*Email" 
                              v-model.lazy.trim="$v.record.email.$model"
                              :state="chkState('email')"
                              aria-describedby="invalidEmailFeedback"/>
                <b-form-invalid-feedback id="invalidEmailFeedback">必填</b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                	<b-input-group-text><i class="cui-lightbulb"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="*Username" 
                              v-model.lazy.trim="$v.record.username.$model"
                              :state="chkState('username')"
                              aria-describedby="invalidUNFeedback"/>
                <b-form-invalid-feedback id="invalidUNFeedback">必填</b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                	<b-input-group-text><i class="cui-lock-locked"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="*Password" 
                              v-model.lazy.trim="$v.record.secret.$model"
                              :state="chkState('secret')"
                              aria-describedby="invalidSSFeedback"/>
                <b-form-invalid-feedback id="invalidSSFeedback">必填5位以上的字元</b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-phone-square"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="Phone" 
                              v-model.lazy.trim="record.phone"/>
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                	<b-input-group-text><i class="icon-screen-smartphone icon"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="Handphone" 
                              v-model.lazy.trim="record.handphone"/>
              </b-input-group>
              
	    	</b-form>
	    </b-modal>
	</div>
</template>

<script>
import Vue from 'vue'
import {ServerTable, Event} from 'vue-tables-2'
import { required, minLength, between, email, minValue, integer } from 'vuelidate/lib/validators'
import { setupCalendar, DatePicker } from 'v-calendar'
import vSelect from 'vue-select'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import select2 from 'select2'
import _ from 'lodash'

import 'v-calendar/lib/v-calendar.min.css'

const encrypt    = config.encrypt;
const decrypt    = config.decrypt;
const admin_root = config.admin_root;
const api_root = config.api_root;

const clean_form = {
	firstname:  '',
	lastname:   '',
	company_id: '',
	role_id:    '',
	contact:    '',
	email:      '',
	phone:      '',
	handphone:  '',
	username:   '',
	secret:     ''
};

let $dyn_ajax_selec2    = null;
let $company_id_select2 = null;
let $role_id_select2    = null;

Vue.use(ServerTable)

export default {
	name: 'admin_list',
	notifications,
	components: {
		ServerTable,
		Event,
		vSelect,
		'v-date-picker': DatePicker
    },
	data(){
		let app = this;
		let cannotEdit = app.$state.$get('ccff') === 'N/A' ? false : true;
		
		return {
			cannotEdit,
			gender_options: [
				{label:'男', value:'男'},
				{label:'女', value:'女'},
				{label:'未知', value:'未知'}
			],
			selected_row: null,
			isFindingLoading: false,
			editRowId: null,
			record: Object.assign({}, clean_form),
			showEditorModal: false,
			delRowShowModal: false,
			delRowId: 0,
			delRowMsg: '',
			columns: ['company_id', 'role_id', 'firstname', 'username', 'email', 'phone', 'user_id', 'created'],
			data: [],
			options: {
				debounce: 86400000, // 停止預設的即時搜尋
				headings: {
					company_id: '公司',
					role_id:    '角色',
					firstname:  '姓名',
					username:   '帳號',
					email:      'Email',
					phone:      '電話',
					handphone:  '手機',
					user_id:    '建立人',
					created:    '建立時間'
				},
				orderBy: {
					column: 'created',
					ascending: false
				},
				sortable: ['company_id', 'role_id', 'firstname', 'username', 'email', 'phone', 'handphone', 'user_id', 'created'],
				filterable: ['firstname', 'username', 'email', 'phone', 'handphone'],
				sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
				pagination: {
					chunk: 5,
					edge: false,
					nav: 'scroll'
				},
				perPage: 25,
				requestFunction(data) {
					let action = `${admin_root}/get_list/User`;
					let params = {
						keyset: 'mqtt',
					};

					let ccff = this.$state.$get('ccff');
					if(ccff){
						params['ccff'] = ccff;
					}

					for(let col in data){
						params[col] = data[col];
					}

					return fetch(action, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
						},
						body: JSON.stringify(params)
					}).then(res => res.json()).then(result => {
						return {
							data: result.data || [],
							count: result.count || 0
						};
					}).catch(error => {
						return {
							data: [],
							count: 0
						};
					});
				}//eo requestFunction
			},
			useVuex: false,
	        theme: 'bootstrap4',
	        template: 'default'
		};//eo return
	},//eo data
	mounted(){
		// Search field 按下Enter後開始搜尋
		this.$nextTick(() => {
			let searchInput = document.querySelector('.VueTables__search-field input');
			if (searchInput) {
				// 取消 Vue Tables 內部的即時搜尋
				/*searchInput.addEventListener('input', (event) => {
					console.info('searchInput event:', event);
				}, true); // 捕獲模式，確保先執行*/

				// 監聽 Enter 鍵，才真正搜尋
				searchInput.addEventListener('keyup', (event) => {
					//console.info('keyup: ', event.key);
					//this.showSuccess({message:`key: ${event.key}`});
					if (event.key === "Enter" || event.key === "Go" || event.key === "Search") {
						this.$refs.dataTable.setFilter(searchInput.value);

						//強制清除 Vue Tables 內部的 debounce 計時器
						//this.$refs.dataTable.query = searchInput.value; // 直接覆寫內部值，避免 24 小時後觸發
					}
				});

				// 監聽 "失去焦點" (按 "下一步" 後，強制搜尋)
				searchInput.addEventListener('blur', () => {
					//console.info('blur event: 搜尋觸發');
					//this.showSuccess({message:'blur event: 搜尋觸發'});
					this.$refs.dataTable.setFilter(searchInput.value);
				});
			}
		});
	},
	methods: {

		editRow(row_id, row) {
			// console.info('edit row_id:', row_id);
			this.selected_row = row;
			this.openEditor(row_id);
			
			this.record = Object.assign({}, this.selected_row);
		},//eo editRow

		delRow(row_id, row_name) {
			// console.info('del row_id:', row_id);

			this.delRowShowModal = row_id ? true : false;
			this.delRowId        = row_id;
			this.delRowMsg       = `您確定要刪除${row_name}嗎？`;
		},//eo delRow

		submitDelRow(row_id) {
			let app    = this;
			let action = `${admin_root}/update_user`;
			let params = {
			    keyset: 'mqtt',
			    record: encodeURIComponent(encrypt(JSON.stringify({
			    	id: row_id,
			    	field: 'valid',
			    	value: 0,
			    	value_type: 'int'
			    })))
			};
			
			fetch(action, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
				},
				body: JSON.stringify(params)
			}).then(res => res.json()).then(result => {
				// console.info('result:', result);
				if(result.success){
					app.showSuccess({
						title: '資料更新成功',
						message: result.message
					});

					app.$refs['dataTable'].refresh();
				} else {
					app.showError({
						title: '資料更新失敗',
						message: result.message
					});
				}
			}).catch(error => {
				app.showError({
					title: '資料更新失敗',
					message: error
				});
			});
		},

		testRow(row_id) {
			console.info('test row_id:', row_id);
			this.showWarn({
				message: '開發中',
				title: '功能暫停'
			});
		},//eo testRow

		chkState(val) {
	      const field = this.$v.record[val];
	      return !field.$dirty || !field.$invalid;
    	},

    	openEditor(row_id){
    		this.editRowId       = row_id;
    		this.showEditorModal = true;
    		this.$v.$reset();

    		let page_limit = 10;
    		let app        = this;

    		//workaround for select2 to be able to use search input
    		jQuery('div.modal-content').removeAttr('tabindex');

    		$company_id_select2 = jQuery('#device-company-id');
    		$role_id_select2    = jQuery('#device-role-id');

    		let ccff = this.$state.$get('ccff');
    		if(ccff && ccff !== 'N/A'){
    			ccff = config.decrypt(ccff, config.ffkey, config.ffiv);
    			$company_id_select2.parents('div.input-group').hide();
    			app.record.company_id = ccff;
    			app.ccff              = ccff;
    		}

    		if($company_id_select2.length){
				//init select2
				$company_id_select2.select2({
					width: 'copy',
					dropdownAutoWidth: true,
					placeholder: '所屬公司...',
					allowClear: true,
					ajax: { // instead of writing the function to execute the request we use Select2's convenient helper
						url: `${admin_root}/get_option_list/Company`,
						type: 'POST',
						dataType: 'json',
						quietMillis: 800 ,
						beforeSend: function (xhr) {
							xhr.setRequestHeader(
								"Authorization",
								"Bearer " + app.$state.$get('adminuser').token
							);
						},
						data: function (params) {
							let preselected_id = jQuery(this).val();
							return {
								preselected_id: preselected_id,
								query:          params.term, // search term
								page_limit:     page_limit,
								page:           params.page || 1
							};
						},
						results: function (data, page) {
							var more = (page * page_limit) < data.total;
							return {results: data.results, more: more};
						}
					},//eo ajax
				}).on('change', (event) => {
					app.record.company_id = $company_id_select2.select2('val');
				});
			}//eo $company_id_select2 init

			if($role_id_select2.length){
				//init select2
				$role_id_select2.select2({
					width: 'copy',
					dropdownAutoWidth: true,
					placeholder: '所屬角色...',
					allowClear: true,
					ajax: { // instead of writing the function to execute the request we use Select2's convenient helper
						url: `${admin_root}/get_option_list/Role`,
						type: 'POST',
						dataType: 'json',
						quietMillis: 800 ,
						beforeSend: function (xhr) {
							xhr.setRequestHeader(
								"Authorization",
								"Bearer " + app.$state.$get('adminuser').token
							);
						},
						data: function (params) {
							let preselected_id = jQuery(this).val();
							return {
								preselected_id: preselected_id,
								query:          params.term, // search term
								page_limit:     page_limit,
								page:           params.page || 1
							};
						},
						results: function (data, page) {
							var more = (page * page_limit) < data.total;
							return {results: data.results, more: more};
						}
					},//eo ajax
				}).on('change', (event) => {
					app.record.role_id = $role_id_select2.select2('val');
				});
			}//eo $role_id_select2 init

			//workaround for Bootstrap4
			if($company_id_select2.data('select2')){
				$company_id_select2.data('select2').$container.addClass("form-control");
			}
			if($role_id_select2.data('select2')){
				$role_id_select2.data('select2').$container.addClass("form-control");
			}

			if(row_id && app.selected_row){

				let $option1 = jQuery('<option selected>讀取中...</option>').val(app.selected_row.company_id);
				let $option2 = jQuery('<option selected>讀取中...</option>').val(app.selected_row.role_id);

				$company_id_select2.val(app.selected_row.company_id).trigger('change');
				$role_id_select2.val(app.selected_row.role_id).trigger('change');
				
				let action = `${admin_root}/get_option_list/Company`;
				fetch(action, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
					},
					body: JSON.stringify({
						id: app.selected_row.company_id
					})
				}).then(res => res.json()).then(result => {
					if(result.results.length){
						let rec = result.results.pop();
						$option1.text(rec.text).val(rec.id);
						$option1.removeData();

						$company_id_select2.html('');

						$company_id_select2.append($option1);

						$company_id_select2.trigger({
						    type: 'select2:select',
						    params: {
						      data: rec
						    }
						});

						$company_id_select2.val(rec.id).trigger('change');
					} else {
						// $option.revmove();
						$company_id_select2.val(null);
						app.showError({
							message: '無法讀取公司資料，請重新指定'
						});
					}
				}).catch(error => {
					// $option.revmove();
					$company_id_select2.val(null);
					app.showError({
						message: '無法讀取公司資料，請重新指定'
					});
				});

				action = `${admin_root}/get_option_list/Role`;
				fetch(action, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
					},
					body: JSON.stringify({
						id: app.selected_row.role_id
					})
				}).then(res => res.json()).then(result => {
					if(result.results.length){
						let rec = result.results.pop();
						$option2.text(rec.text).val(rec.id);
						$option2.removeData();

						$role_id_select2.html('');

						$role_id_select2.append($option2);

						$role_id_select2.trigger({
						    type: 'select2:select',
						    params: {
						      data: rec
						    }
						});

						$role_id_select2.val(rec.id).trigger('change');
					} else {
						// $option.revmove();
						$role_id_select2.val(null);
						app.showError({
							message: '無法讀取角色資料，請重新指定'
						});
					}
				}).catch(error => {
					// $option.revmove();
					$role_id_select2.val(null);
					app.showError({
						message: '無法讀取角色資料，請重新指定'
					});
				});
			}

    		if(!row_id){
				app.record       = Object.assign({}, clean_form);
				app.selected_row = null;
				app.row_id       = null;
			}
    	},

    	submitRecord() {

    		let app    = this;
    		let row_id = app.editRowId;

    		this.$v.$touch();

		    if (this.$v.$invalid) {
		        this.showError({message:'請輸入必填欄位', title:'資料錯誤'});
		        this.showEditorModal = true;
		        return false;
		    }

		    let to_save = this.record;

		    if(row_id){
		    	to_save['id'] = row_id;
		    }

		    let selected_company = $company_id_select2.select2('data').pop();

		    // console.info('selected_company:', selected_company);return;

		    if(selected_company){
		    	to_save['company'] = selected_company.text;
		    }

		    if(app.ccff){
		    	to_save['company_id'] = app.ccff;
		    	to_save['company']    = this.$state.$get('company_name');
		    }

		    // console.info('before send: ', to_save);

		    to_save = encodeURIComponent(encrypt(JSON.stringify(to_save)));

		    let action = `${admin_root}/save_user`;
		    let params = {
		    	keyset: 'mqtt',
		    	record: to_save
		    };

			fetch(action, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
				},
				body: JSON.stringify(params)
			}).then(res => res.json()).then(result => {
				if(result.success){
		    		app.showSuccess({
		    			title: '成功',
		    			message: '資料成功儲存'
		    		});
		    		app.$refs['dataTable'].refresh();
		    		app.record = Object.assign({}, clean_form);
		    		app.$v.$reset();
		    	} else {
		    		let cat_msg = '';

		    		if(result.error && result.error.errors && result.error.errors.length){
		    			result.error.errors.forEach((err) => {
		    				cat_msg += "\n" + `[${err.type}]:` +err.message + "\n";
		    			});
		    		}

		    		app.showError({
		    			title: '錯誤',
		    			message: '無法儲存資料，請稍後再試。'+cat_msg,
		    			timeout: 10000
		    		});
		    		app.$refs['dataTable'].refresh();
		    	}
			}).catch(error => {
				app.showError({
					title: '錯誤',
					message: '無法儲存資料，請稍後再試。',
					timeout: 10000
				});
				app.$refs['dataTable'].refresh();
			});
    	},
		unlockUserLoginFail(row_id, row) {
			let app = this;
			if(row && row.username && row.username.length > 0) {
				let action = `${api_root}/user/reset_user_login_fail`;
				fetch(action, {
					method: 'POST',
					headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
					},
					body: JSON.stringify({
						keyset: 'mqtt',
						access: encodeURIComponent(encrypt(row.username)),
					})
				}).then(res => res.json()).then(result => {
					if(result && result.success) {
						app.showSuccess({
							title: '帳號解鎖',
							message: '帳號解鎖成功'
						});
					} else {
						app.showError({
							title: '帳號解鎖',
							message: '帳號解鎖失敗'
						});
					}
				}).catch(error => {
					app.showError({
						title: '帳號解鎖',
						message: '帳號解鎖失敗'
					});
				});
			}
		},//eo editRow
	},//eo methods
	validations: {
		record: {
			firstname: {
			  required,
			  minLength: minLength(1)
			},
			lastname: {
			  required,
			  minLength: minLength(1)
			},
			company_id: {
			  required: false,
			  // integer,
			  // minLength: minLength(1)
			},
			role_id: {
			  required,
			  integer,
			  minLength: minLength(1)
			},
			contact: {
			  required,
			  minLength: minLength(1)
			},
			email: {
			  required,
			  email
			},
			username: {
			  required,
			  minLength: minLength(5)
			},
			secret: {
			  required,
			  minLength: minLength(5)
			}
		}
	},//eo validations
	
};
</script>
<style lang="scss">
.card-body{padding:0;}
.add-btn{}
.multiselect__input{width:100%;border:none;}

#dataTable {
	width: 95%;
	margin: 0 auto;
	margin-top: 0.5rem;
	font-size: 0.75rem;

	.VuePagination {
	  text-align: center;
	  justify-content: center;
	}

	.vue-title {
	  text-align: center ;
	  margin-bottom: 10px;
	}

	.VueTables__search-field {
	  display: flex;
	}
	.VueTables__search-field input {
	  margin-left: 0.25rem;
	}

	.VueTables__limit-field {
	  display: flex;
	}

	.VueTables__limit-field select {
	  margin-left: 0.25rem !important;
	}

	.VueTables__table th {
	  text-align: center;
	}

	.VueTables__child-row-toggler {
	  width: 16px;
	  height: 16px;
	  line-height: 16px;
	  display: block;
	  margin: auto;
	  text-align: center;
	}

	.VueTables__child-row-toggler--closed::before {
	  content: "+";
	}

	.VueTables__child-row-toggler--open::before {
	  content: "-";
	}

	.VueTables__sortable {
		padding: 0.25rem;
	}
}
</style>
